import React, { Component } from 'react'
import DataHeader from "./containers/DataHeader"
import DataTable from "./containers/DataTable"
import dataIcon from "app/styles/images/sp/data-selected.svg"
import { observer, Provider } from "mobx-react"
import recycleDetail from "app/stores/arrayPgt/recycleDetail"

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.recycleDetail = new recycleDetail()
    this.recycleDetail.setFamilyId(props.match.params.id)
  }
  render() {
    return (
      <Provider recycleDetail={this.recycleDetail}>
        <div className="datamanage-detail-page pgd">
          <h2 className="page-title">
            <img alt="" src={dataIcon} />
            回收站 > 数据详情
          </h2>
          <div className="clearfix wrapper-box-first">
            <DataHeader />
          </div>
          <div>
            <DataTable />
          </div>
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/recycle_detail/index.js